module.exports = __webpack_public_path__ + "img/232.69b6b3e3.png";